<div id="container">
  @if (!taxYrCreated) {
  <div>
    <h3>{{ 'settings.create-new-year-label' | transloco: {yearLabel} }}</h3>
    Note: the following will be copied over to the new {{ yearLabel }}:
    <div class="ui list">
      <div class="item">
        {{ 'settings.tax-return-alias-questions' | transloco: {taxReturnAlias} }}
      </div>
      <div class="item">{{ "settings.calculation-plans" | transloco }}</div>
      <div class="item">{{ "settings.source-questions" | transloco }}</div>
      <div class="item">{{ "settings.client-questions" | transloco }}</div>
      <div class="item">{{ "settings.population-answers" | transloco }}</div>
    </div>
    <div class="ui primary background button" (click)="showConfirmModal()">
      {{ 'settings.create-year-label-for-new-tax-yr' | transloco: {yearLabel} }}
      {{ newTaxYr }}
    </div>
  </div>
  } @if (taxYrCreated) {
  <div>
    <h3>{{ 'settings.new-year-label-queued' | transloco: {yearLabel} }}</h3>
    You will be notified when the new {{ yearLabel }} has been created
    successfully.
  </div>
  }

  <div #successModal id="success-modal" class="ui tiny modal">
    <div class="icon modal-close close"></div>

    <div class="content">
      <div class="icon green-success"></div>
      <h3>
        {{ yearLabel }} <strong>{{ newTaxYr }}</strong> Queued Successfully
      </h3>
    </div>

    <div class="actions">
      <div class="ui primary background button approve">
        {{ "settings.ok" | transloco }}
      </div>
    </div>
  </div>
</div>

<div #newTaxYrModal id="new-yr-modal" class="ui tiny modal">
  <div class="icon modal-close close"></div>

  <h2>{{ "settings.are-you-sure" | transloco }}</h2>

  <div class="content">
    {{ 'settings.please-confirm-you-want-to-create-a-new-year-label-for' | transloco: {yearLabel} }}
    {{ newTaxYr }}
  </div>

  <div class="actions">
    <div
      (click)="createNewTaxYr()"
      class="ui primary background button"
      [ngClass]="{ loading: isLoading }"
    >
      {{ "settings.yes-create" | transloco }}
    </div>
  </div>
</div>
